export default class UserSessionStateMessage {
    timestamp: number | undefined;
    success: boolean = false;
    
    constructor(init?: UserSessionStateMessage) {
        Object.assign(this, init);
    }
}
